<div class="user-wrapper">
  <img
    [matMenuTriggerFor]="userMenu"
    [src]="avatar()"
    alt="..."
    class="user-icon" />

  <mat-menu #userMenu="matMenu" xPosition="before">
    <div class="user-menu">
      <div class="user-menu-item">
        {{ user?.providerData?.[0]?.email }}
      </div>
      <button (click)="signOutEmit()" mat-raised-button color="primary">
        Sign out
      </button>
    </div>
  </mat-menu>

  <p class="greeting-text">
    Hi, <span class="user-name">{{ user?.displayName }}</span>
  </p>
</div>
